module.exports = __webpack_public_path__ + "static/media/pic6.99434b4f.jpg";